import {
  INSTORE_OFFERS_SECTION_TITLE_GET_SUCCESS, INSTORE_OFFERS_SECTION_TITLE_GET_FAILURE,
} from 'core/modules/Instore2/actions/types';

const initialState = {
  defaults: {
    title: '',
    isLoading: false,
    isLoaded: false,
  },
};

export default (state = initialState, action) => {
  const namespaceId = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const namespace = `namespace-${namespaceId}`;
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case INSTORE_OFFERS_SECTION_TITLE_GET_SUCCESS: {
      const title = action.payload?.response?.[0]?.assets?.text || '';

      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          title,
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case INSTORE_OFFERS_SECTION_TITLE_GET_FAILURE: {
      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          title: '',
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === INSTORE_OFFERS_SECTION_TITLE_GET_SUCCESS) {
        return {
          ...state,
          [namespace]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};
